import { render } from "./problemListView.vue?vue&type=template&id=0d13a45b"
import script from "./problemListView.vue?vue&type=script&lang=js"
export * from "./problemListView.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\GPTWeb\\licCode\\lic\\webviewer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__